import { handleChatBot } from "../../utils";
const UpArrowQuestion = () => {
    return (
        <div>
            <div class="pullUp" onClick={() => window.scrollTo({ top: 0, behaviour: 'smooth' })}>
                <b class="icon-arrow-right"></b>
            </div>
            <div className="quickFAQ" onClick={(e) => handleChatBot(e)}>
                <div >
                    <p>Questions?</p>
                    <span>Talk to Us</span>
                </div>
            </div>
        </div>
    )
}

export default UpArrowQuestion